import { useTranslation } from "react-i18next";

const werkItems = [
  {
    caption: "Kozijn PVC hersteld",
    alt: "PVC kozijnreparatie met professioneel gereedschap",
    img: "/img/91-foto.jpeg",
    span: "md:col-span-2 md:row-span-1",
    aspect: "aspect-[3/2]",
  },
  {
    caption: "Schuifpui afgesteld",
    alt: "Schuifpui roller mechanisme wordt afgesteld",
    img: "/img/99-foto.jpeg",
    span: "",
    aspect: "aspect-[3/4]",
  },
  {
    caption: "HR++ glas geplaatst",
    alt: "HR++ isolatieglas installatie in kozijn",
    img: "/img/102-foto.jpeg",
    span: "md:row-span-2",
    aspect: "aspect-[3/4]",
  },
  {
    caption: "Draaikiepmechanisme gerepareerd",
    alt: "Draaikiepraam mechanisme reparatie detail",
    img: "/img/97-foto.jpeg",
    span: "",
    aspect: "aspect-square",
  },
  {
    caption: "Slot vervangen SKG***",
    alt: "SKG gekeurd cilinderslot vervanging in deur",
    img: "/img/78-foto.jpeg",
    span: "",
    aspect: "aspect-[3/4]",
  },
  {
    caption: "Houten kozijn geschilderd",
    alt: "Houten kozijn restauratie en schilderwerk",
    img: "/img/82-foto.jpeg",
    span: "md:col-span-2",
    aspect: "aspect-[3/2]",
  },
  {
    caption: "Velux dakraam hersteld",
    alt: "Velux dakraam reparatie in zolder",
    img: "/img/79-foto.jpeg",
    span: "",
    aspect: "aspect-square",
  },
  {
    caption: "Rubbers vervangen",
    alt: "Nieuwe raamrubbers worden geplaatst in PVC kozijn",
    img: "/img/90-foto.jpeg",
    span: "md:row-span-2",
    aspect: "aspect-[3/4]",
  },
  {
    caption: "Kozijnprofiel hersteld",
    alt: "PVC kozijnprofiel reparatie met warmte en gereedschap",
    img: "/img/80-foto.jpeg",
    span: "",
    aspect: "aspect-[3/2]",
  },
];

export default function Realisaties() {
  const { t } = useTranslation("home");

  return (
    <section id="realisaties" className="bg-white py-20 md:py-[120px] w-full">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14 md:mb-20">
          <h2 className="font-geist font-bold text-3xl md:text-[48px] text-brand-text mb-4">
            Voorbeelden van ons werk
          </h2>
          <p className="font-geist text-base md:text-lg text-brand-text/60 max-w-[700px] mx-auto">
            Een impressie van de werkzaamheden die wij uitvoeren aan kozijnen, ramen en deuren in de regio Eindhoven.
          </p>
        </div>

        {/* Masonry Grid */}
        <div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 auto-rows-[200px] sm:auto-rows-[220px] lg:auto-rows-[240px]"
          style={{ gridAutoFlow: "dense" }}
        >
          {werkItems.map((item, i) => (
            <div
              key={i}
              className={`group relative rounded-2xl overflow-hidden cursor-pointer ${item.span}`}
            >
              <img
                src={item.img}
                alt={item.alt}
                className={`w-full h-full object-cover transition-all duration-300 group-hover:scale-105 group-hover:brightness-110 ${item.aspect}`}
                loading="lazy"
              />

              {/* Hover overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#0C2740]/90 via-[#0C2740]/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end">
                {/* Yellow accent line */}
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-[#FFD600] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" />

                {/* Caption */}
                <div className="p-4 md:p-5">
                  <p className="font-geist font-bold text-sm md:text-base text-white">
                    {item.caption}
                  </p>
                  <div className="flex items-center gap-1.5 mt-1">
                    <div className="w-2 h-2 rounded-full bg-[#FFD600]" />
                    <span className="font-geist text-xs text-white/70">
                      Bekijk details
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}